import { Alert } from '@material-ui/lab';
import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useApiRequest } from 'src/hooks/useApi';
import { useAppToolchain } from 'src/hooks/useAppToolchain';
import useAuth from 'src/hooks/useAuth';
import LoadingIndicator from 'src/lib/components/LoadingIndicator';
import  EmailSettingsForm  from 'src/routes/settings/email/EmailSettingsForm';
import { CodeusAccountState } from 'src/types/dataTypes';
import useStyles from 'src/styles/di-theme';
import classNames from 'classnames';
import { usePageTitle } from 'src/hooks/useMastheadTitle';

function EmailSettings(): ReactElement {
	usePageTitle('Notifications');
	const { auth } = useAuth();
	const { api } = useAppToolchain();
	const classes = useStyles();

	const [status, tierState, err] = useApiRequest<CodeusAccountState>(
		(signal) =>
			api.getAccountTierState(auth.accountDetails.account.id, {
				signal,
			}),
		[],
	);

	if (!auth?.isFullAdmin()) {
		return <Navigate to="/settings/" />;
	}

	if (!tierState) return <LoadingIndicator />;

	if (err) {
		return (
			<Alert severity="error">
				An error occured while loading settings.
			</Alert>
		);
	}

	return (
		<>
			<div
				className={classNames(
					classes['pt_4'],
					classes['plr_4'],
				)}
			>
				{tierState.state === 'Free' ? (
					<Alert severity="info">
						Notifications are disabled for accounts in free mode.
					</Alert>
				) : (
					<>
						<EmailSettingsForm />
					</>
				)}
			</div>
		</>
		
	);
}

export default EmailSettings;
